import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { appState } from '../../../../constants/app-state';

@Component({
  selector: 'arm-create-message',
  templateUrl: './create-message.component.html',
  styleUrls: ['./create-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateMessageComponent implements OnInit, OnDestroy {

  constructor() { }

  public ngOnInit(): void {
    appState.getValue().progressBar.next({
      show: true,
      value: 100 / 4,
    });
  }

  public ngOnDestroy(): void {
    appState.getValue().progressBar.next({
      show: false,
      value: 0,
    });
  }
}
